import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { FormlyFieldInput } from '@ngx-formly/material/input';

export interface FormlyInputFieldConfig
  extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'input' | Type<FormlyFieldInput>;
}

@Component({
  selector: 'vmspdb-component-formly-timepicker',
  templateUrl: './formly-timepicker.component.html',
  styleUrls: ['./formly-timepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormlyTimepickerComponent extends FieldType<
  FieldTypeConfig<FormlyFieldProps>
> {}
